"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = void 0;

var _react = require("react");

var _ThemeProvider = require("./ThemeProvider");

var useTheme = function useTheme() {
  return (0, _react.useContext)(_ThemeProvider.ThemeContext);
};

exports.useTheme = useTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VUaGVtZSIsInVzZUNvbnRleHQiLCJUaGVtZUNvbnRleHQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dHMvVGhlbWUvdXNlVGhlbWUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgVGhlbWVDb250ZXh0LCBUaGVtZVByb3ZpZGVyVmFsdWUgfSBmcm9tICcuL1RoZW1lUHJvdmlkZXInO1xuXG5leHBvcnQgY29uc3QgdXNlVGhlbWUgPSAoKSA9PiB1c2VDb250ZXh0PFRoZW1lUHJvdmlkZXJWYWx1ZT4oVGhlbWVDb250ZXh0KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLFFBQVEsR0FBRyxTQUFYQSxRQUFXO0VBQUEsT0FBTSxJQUFBQyxpQkFBQSxFQUErQkMsMkJBQS9CLENBQU47QUFBQSxDQUFqQiJ9